<div class="card" [attr.data-testid]="contentTestId()">
  @if (attributes().length > 0) {
    <div class="space-y-3" [attr.data-testid]="contentTestId() + '-content'">
      <div class="mb-4">
        <h3 class="text-lg font-semibold">
          {{ 'provider.tenderResponse.subcriteriaAttributes.attributesTitle' | transloco }}
        </h3>
        @if (!disabled()) {
          <p class="text-sm text-gray-600 mt-1">
            {{ 'provider.tenderResponse.subcriteriaAttributes.attributesDescription' | transloco }}
          </p>
        }
      </div>

      <app-badge-list
        [items]="visibleBadgeListItems()"
        [headerInputTemplate]="headerInputTemplate"
        [contentTemplate]="suggestionReviewTemplate"
        [isOpenable]="reviewEnabled()"
        (itemToggle)="onItemToggle($event)"
        [attr.data-testid]="attributesListTestId()"
      >
        <ng-template #headerInputTemplate let-item>
          <div class="flex items-center gap-3">
            <app-suggestion-status-tag [attributeDirectusId]="item.key" />

            @if (item.originalItem?.importanceScore && showImportanceScore()) {
              <span
                class="text-base text-gray-500 min-w-0 shrink-0"
                [attr.data-testid]="'attribute-type-' + item.key"
              >
                {{ item.originalItem.importanceScoresTranslationKey | transloco }}
              </span>
            }

            <app-attribute-fulfillment-input
              [attribute]="item.originalItem"
              [twoStage]="twoStage()"
              [disabled]="disabled() || isSaving()"
              [readonly]="disabled()"
              [testIdKey]="item.key"
              (valueChange)="
                attributeScoreChanged({
                  directusId: item.originalItem.directusId,
                  score: $event.score,
                  scoreAbsent: $event.scoreAbsent,
                  capabilityLevel: $event.capabilityLevel,
                  provisioningType: $event.provisioningType,
                  comment: item.originalItem.comment,
                })
              "
            />
            <app-comment-modal-button-model
              [value]="item.originalItem.comment"
              [isReadOnly]="disabled()"
              (valueChange)="
                commentChange.emit({
                  directusId: item.originalItem.directusId,
                  score: item.originalItem.score,
                  comment: $event,
                })
              "
            />
          </div>
        </ng-template>

        <ng-template #suggestionReviewTemplate let-item>
          <app-template-suggestion-review
            [attribute]="item.originalItem"
            [twoStage]="twoStage()"
            [expanded]="isExpanded(item.key)"
            [disabled]="disabled()"
          />
        </ng-template>
      </app-badge-list>

      @if (showsFilterEmptyHint()) {
        <p-message
          severity="info"
          variant="simple"
          size="small"
          data-testid="suggestion-filter-empty"
        >
          {{ 'provider.templates.suggestions.filter.empty' | transloco }}
        </p-message>
      }

      @if (canSaveAttributes()) {
        <div class="flex justify-end mt-3" data-testid="save-actions">
          <p-button
            label="{{ 'common.save' | transloco }}"
            (onClick)="saveClick.emit()"
            [disabled]="isSaving()"
            [loading]="isSaving()"
            severity="primary"
            data-testid="save-subcriteria-attributes-btn"
          />
        </div>
      }
    </div>
  } @else {
    <div class="text-center py-8" data-testid="no-attributes-message">
      <i class="pi pi-info-circle text-2xl text-gray-400 mb-3"></i>
      <h4 class="text-md font-semibold text-gray-600 mb-2">
        {{ 'shared.subcriteriaAttributes.noSubcriteriaTitle' | transloco }}
      </h4>
      <p class="text-gray-500 text-sm">
        {{ 'shared.subcriteriaAttributes.noSubcriteriaMessage' | transloco }}
      </p>
    </div>
  }
</div>
